import FormattedMessage from 'I18n/components/FormattedMessage';
import { CARD_PAYMENT_TYPE } from '../constants/payments';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import usePaymentHighlightProperties from '../hooks/usePaymentHighlightProperties';
import StoredPMOFTag from './StoredPMOFTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const commerceHubPaymentMethods = new Set(['ach', 'card', 'sepa', 'pads', 'bacs']);
const PaidWithCommerceHub = ({
  propertyDefinition,
  last4,
  paymentMethodType,
  bankOrIssuer,
  objectId
}) => {
  var _data$crmObject;
  const {
    data
  } = usePaymentHighlightProperties(objectId);
  const isPaymentMethodOnFileActive = data === null || data === void 0 || (_data$crmObject = data.crmObject) === null || _data$crmObject === void 0 ? void 0 : _data$crmObject.isPaymentMethodOnFileActive;
  if (paymentMethodType === CARD_PAYMENT_TYPE) {
    if (isPaymentMethodOnFileActive) {
      return /*#__PURE__*/_jsx(StoredPMOFTag, {
        bankOrIssuer: bankOrIssuer,
        last4: last4
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWithCard",
      options: {
        bankOrIssuer,
        last4
      }
    });
  }
  const paymentMethodOption = propertyDefinition.options.find(option => option.value === paymentMethodType);
  if (paymentMethodOption) {
    if (isPaymentMethodOnFileActive) {
      return /*#__PURE__*/_jsx(StoredPMOFTag, {
        bankOrIssuer: bankOrIssuer,
        last4: last4
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWithBankAccount",
      options: {
        paymentMethodType: paymentMethodOption.label,
        last4
      }
    });
  }
  return null;
};
const PaidWithExternalProcessor = ({
  objectId,
  propertyDefinition,
  paymentMethodType,
  referenceNumber
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWith"
    }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
      objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
      objectId: objectId,
      property: propertyDefinition,
      value: paymentMethodType,
      getAdditionalPropertyValue: () => undefined
    }), referenceNumber ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [" ", referenceNumber]
    }) : null]
  });
};
const PaymentMethodFormatter = ({
  objectId,
  propertyDefinition,
  paymentCreationMethod,
  paymentMethodType,
  referenceNumber,
  last4,
  bankOrIssuer
}) => {
  const isCommerceHubPayment = paymentCreationMethod === 'PAYMENTS_PROCESSOR';
  if (!paymentMethodType) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "formatted-payment-method",
    children: isCommerceHubPayment && commerceHubPaymentMethods.has(paymentMethodType !== null && paymentMethodType !== void 0 ? paymentMethodType : '') ? /*#__PURE__*/_jsx(PaidWithCommerceHub, {
      propertyDefinition: propertyDefinition,
      last4: last4,
      paymentMethodType: paymentMethodType,
      bankOrIssuer: bankOrIssuer,
      objectId: objectId
    }) : /*#__PURE__*/_jsx(PaidWithExternalProcessor, {
      objectId: objectId,
      propertyDefinition: propertyDefinition,
      paymentMethodType: paymentMethodType,
      referenceNumber: referenceNumber
    })
  });
};
export default PaymentMethodFormatter;